import axios from 'axios'
import url from '../url.js'

function getCheckoutInfo (data) {
  return fetch(url.orderCheckoutInfo, data)
}
function getDetail (data) {
  return fetch(url.orderDetail, data)
}
function applyVoucher (data) {
  return fetch(url.orderApplyVoucher, data)
}
function complete (data) {
  return fetch(url.orderComplete, data)
}
function thankyou (data) {
  return fetch(url.orderThankyou, data)
}
function getList (data) {
  return fetch(url.orderGetPaging, data)
}
function remove (data) {
  return fetch(url.orderRemove, data)
}
const cancelToken = axios.CancelToken
const source = cancelToken.source()
function fetch (urlString, data) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'POST',
      url: urlString,
      data: data,
      dataType: 'json',
      cancelToken: source.token
    })
      .then(response => {
        resolve(response)
      })
      .catch(a => {
      })
  })
}
function cancelRequest () {
  source.cancel('cancel')
}

export default {
  getCheckoutInfo (data) {
    return getCheckoutInfo(data)
  },
  getDetail (data) {
    return getDetail(data)
  },
  applyVoucher (data) {
    return applyVoucher(data)
  },
  complete (data) {
    return complete(data)
  },
  thankyou (data) {
    return thankyou(data)
  },
  getList (data) {
    return getList(data)
  },
  remove (data) {
    return remove(data)
  },
  cancelRequest () {
    cancelRequest()
  },
  changeDeliveryDate (data) {
    return fetch(url.orderUpdateDelivery, data)
  }
}



// WEBPACK FOOTER //
// ./src/api/order/index.js